import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import Notifications from 'vue-notification'
import VueProgressBar from 'vue-progressbar'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapMarkedAlt, faTable, faSlidersH, faFileInvoiceDollar, faMapMarkerAlt, faSearch, faCalendarAlt, faTags, faEuroSign, faFileAlt, faCity, faTrashAlt, faInfoCircle, faEdit, faFilePdf, faFileDownload} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueApexCharts from 'vue-apexcharts'

library.add(faMapMarkedAlt, faTable, faSlidersH, faFileInvoiceDollar, faMapMarkerAlt, faSearch, faCalendarAlt, faTags, faEuroSign, faFileAlt, faCity, faTrashAlt, faInfoCircle, faEdit, faFilePdf, faFileDownload)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Notifications)
Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(VueApexCharts)

Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App, {props: {islogged: true}})
}).$mount('#app')

/* CONFIG */
import {globalConf} from './config.global'
Vue.prototype.$hostlink = globalConf.hostlink

/*GLOBAL*/
Vue.prototype.$sidebar = {
  stato: false,
  cerca: false,
  cercaAziende: false,
  trovatoAziende: false
}

/*GLOBAL SIDEBAR*/
import {sidebarData, sidebarValue} from './config.global'
Vue.prototype.$sidebarData = sidebarData.data
Vue.prototype.$sidebarValue = sidebarValue
Vue.prototype.$sidebarValue.listaAziende = []

/*VUE-RESONCE INTERCEPTOR*/
Vue.http.interceptors.push(function(request) {
  Vue.prototype.$Progress.start()
  return function(response) {
    Vue.prototype.$Progress.finish()
    if(response.status == 500 && response.bodyText == "Error!"){
      location.reload()
    }
  }
})

//Vue.config.silent = true